import { render } from "./DetailProfile.vue?vue&type=template&id=719f9bf7&scoped=true"
import script from "./DetailProfile.vue?vue&type=script&lang=js"
export * from "./DetailProfile.vue?vue&type=script&lang=js"

import "./DetailProfile.vue?vue&type=style&index=0&id=719f9bf7&scoped=true&lang=css"
import "./DetailProfile.vue?vue&type=style&index=1&id=719f9bf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719f9bf7"]])

export default __exports__